import { SystemService } from "./SystemService";
import AuthService from "./AuthService";

class EssService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getAllLeaveRequests() {
        let sessionId = this.authService.getSessionId();
        return this.api.get('ess/all-leave-requests', {
            headers: { authorization: sessionId }
        });
    }

    getAllAdvancePayments() {
        let sessionId = this.authService.getSessionId();
        return this.api.get('ess/all-advance-payments', {
            headers: { authorization: sessionId }
        });
    }

    approveLeaveRequest(id) {
        let sessionId = this.authService.getSessionId();
        return this.api.post(`ess/leave-requests/${id}/approve`, {}, {
            headers: { authorization: sessionId }
        });
    }

    rejectLeaveRequest(id, rejectionReason) {
        let sessionId = this.authService.getSessionId();
        return this.api.post(`ess/leave-requests/${id}/reject`, { rejectionReason }, {
            headers: { authorization: sessionId }
        });
    }

    approveAdvancePayment(id) {
        let sessionId = this.authService.getSessionId();
        return this.api.post(`ess/advance-payments/${id}/approve`, {}, {
            headers: { authorization: sessionId }
        });
    }

    rejectAdvancePayment(id, rejectionReason) {
        let sessionId = this.authService.getSessionId();
        return this.api.post(`ess/advance-payments/${id}/reject`, { rejectionReason }, {
            headers: { authorization: sessionId }
        });
    }

    getHeadroom(specialty, whs, startDate, endDate) {
        let sessionId = this.authService.getSessionId();
        return this.api.get('ess/headroom', {
            params: { specialty, whs, startDate, endDate },
            headers: { authorization: sessionId }
        });
    }

    getLeaveTypes() {
        let sessionId = this.authService.getSessionId();
        return this.api.get('ess/leave-types', {
            headers: { authorization: sessionId }
        });
    }

    createLeaveType(name, daysLimit = null, isSpecial = false, description = '') {
        let sessionId = this.authService.getSessionId();
        return this.api.post('ess/leave-types', { name, daysLimit, isSpecial, description }, {
            headers: { authorization: sessionId }
        });
    }

    updateLeaveType(id, name, daysLimit = null, isSpecial = false, description = '') {
        let sessionId = this.authService.getSessionId();
        return this.api.put(`ess/leave-types/${id}`, { name, daysLimit, isSpecial, description }, {
            headers: { authorization: sessionId }
        });
    }

    syncLeaveTypes() {
        let sessionId = this.authService.getSessionId();
        return this.api.post('ess/sync-leave-types', {}, {
            headers: { authorization: sessionId }
        });
    }

    deleteLeaveType(id) {
        let sessionId = this.authService.getSessionId();
        return this.api.delete(`ess/leave-types/${id}`, {
            headers: { authorization: sessionId }
        });
    }

    reorderLeaveTypes(ids) {
        let sessionId = this.authService.getSessionId();
        return this.api.put('ess/leave-types/reorder', { ids }, {
            headers: { authorization: sessionId }
        });
    }

    getSpecialties() {
        let sessionId = this.authService.getSessionId();
        return this.api.get('ess/specialties', {
            headers: { authorization: sessionId }
        });
    }

    createSpecialty(name) {
        let sessionId = this.authService.getSessionId();
        return this.api.post('ess/specialties', { name }, {
            headers: { authorization: sessionId }
        });
    }

    updateSpecialty(id, name) {
        let sessionId = this.authService.getSessionId();
        return this.api.put(`ess/specialties/${id}`, { name }, {
            headers: { authorization: sessionId }
        });
    }

    deleteSpecialty(id) {
        let sessionId = this.authService.getSessionId();
        return this.api.delete(`ess/specialties/${id}`, {
            headers: { authorization: sessionId }
        });
    }
}

export default EssService;
